(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3648],{

/***/ 55153:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/[$partnerName]/localMain",
      function () {
        return __webpack_require__(14270);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96906);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47178);




var Header = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_1__/* .Header */ .h4, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: "국내여행"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
                gap: "30",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_1__/* .ConfirmButton */ .pu, {
                        href: "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_2__/* ["default"].ENV_PACKAGE_URL */ .Z.ENV_PACKAGE_URL, "/accounts/partnersReserveAuth.yb?channelCode=prdt001"),
                        target: "_blank",
                        children: "예약확인"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_1__/* .Logo */ .TR, {
                        href: "#",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/include/images/common/logo_yb.png",
                            alt: "노랑풍선",
                            width: "155",
                            height: "42"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 75412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99653);
/* harmony import */ var _PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93391);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n				height: 20px;\n				background-position: -20px 0;\n			"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n				height: 21px;\n				background-position: -40px 0;\n			"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n				height: 23px;\n				background-position: 0px 0;\n			"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: block;\n	width: 18px;\n	margin-right: 10px;\n	background-image: url(",
        ");\n	background-size: 400px 400px;\n\n	",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SearchIcon = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].i.withConfig({
    componentId: "sc-9a356e47-0"
})(_templateObject3(), (_PUBLIC_P_images_ico_ico_spr_png__WEBPACK_IMPORTED_MODULE_1___default()), function(props) {
    if (props.icon === "calendar") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject());
    }
    if (props.icon === "member") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1());
    }
    if (props.icon === "map") {
        return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject2());
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (SearchIcon);


/***/ }),

/***/ 47178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "kA": function() { return /* reexport */ CompareButtonBox; },
  "y8": function() { return /* reexport */ CompareTextBox; },
  "W2": function() { return /* binding */ Container; },
  "jb": function() { return /* binding */ DescriptionContent; },
  "_O": function() { return /* binding */ DescriptionWrap; },
  "kC": function() { return /* binding */ Flex; },
  "es": function() { return /* binding */ LineBox; },
  "t3": function() { return /* binding */ LineHeader; },
  "ug": function() { return /* binding */ NoteBox; },
  "Ar": function() { return /* binding */ SubTitleWrap; },
  "Xr": function() { return /* reexport */ layout_WarningBox; }
});

// UNUSED EXPORTS: ProdutList, Stack

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
// EXTERNAL MODULE: ./public/P/images/ico/ico_spr.png
var ico_spr = __webpack_require__(99653);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
;// CONCATENATED MODULE: ./components/style/detailpackage/couponselect.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-bottom: 20px;\n	font-size: var(--derault-size);\n	font-weight: normal;\n	color: var(--emp-color);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 20px 30px;\n	border: 1px solid var(--line-color);\n	+ h4 {\n		margin-top: 40px;\n	}\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	font-size: var(--default-size);\n	+ li {\n		margin-top: 10px;\n	}\n	> div {\n		line-height: 1;\n	}\n	label {\n		display: flex;\n		align-items: center;\n		input {\n			flex: 0 0 auto;\n		}\n		> span {\n			em {\n				line-height: 1.6;\n				&::after {\n					display: inline-block;\n					width: 1px;\n					height: 12px;\n					margin: 0 10px;\n					background-color: var(--line-color);\n					content: "";\n				}\n			}\n		}\n	}\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	position: relative;\n	display: inline-block;\n	width: fit-content;\n	line-height: 1;\n	margin-left: 10px;\n	&::before {\n		position: absolute;\n		bottom: -2px;\n		display: inline-block;\n		width: 100%;\n		height: 1px;\n		background-color: var(--default-color);\n		content: "";\n	}\n	&::after {\n		position: absolute;\n		top: 3px;\n		right: -22px;\n		display: inline-block;\n		width: 15px;\n		height: 14px;\n		background: url(',
        ') no-repeat;\n		background-position: -145px 0;\n		content: "";\n	}\n'
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	line-height: 1;\n	color: var(--blue-color);\n	text-decoration: underline;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	margin-top: 40px;\n	text-align: center;\n	font-size: var(--medium-size);\n	color: var(--emp-color);\n	> span {\n		margin-left: 10px;\n		font-size: var(--default-size);\n		color: var(--red-color);\n		em {\n			font-size: 22px;\n		}\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: center;\n	margin: 40px auto 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: 40px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: 10px;\n	li + li {\n		margin-top: 8px;\n	}\n	li {\n		> ul {\n			margin-top: 10px;\n		}\n	}\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var Title = styled_components_browser_esm["default"].h4.withConfig({
    componentId: "sc-72595239-0"
})(_templateObject());
var CouponList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-72595239-1"
})(_templateObject1());
var CouponItem = styled_components_browser_esm["default"].li.withConfig({
    componentId: "sc-72595239-2"
})(_templateObject2());
var DownloadLink = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-72595239-3"
})(_templateObject3(), (ico_spr_default()));
var LinkText = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-72595239-4"
})(_templateObject4());
var TotalPrice = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-72595239-5"
})(_templateObject5());
var SubmitButtonBlock = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-72595239-6"
})(_templateObject6());
var NoteBoxWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-72595239-7"
})(_templateObject7());
var BulletList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-72595239-8"
})(_templateObject8());


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./framework/ui/desktop/layout/CompareBox.tsx



function CompareBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 0;\n	left: 0;\n	z-index: 1;\n	display: flex;\n	gap: 8px;\n	width: 100%;\n	height: 100%;\n	background-color: rgba(0, 0, 0, 0.5);\n	text-align: center;\n	align-items: center;\n	justify-content: center;\n"
    ]);
    CompareBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompareBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 14px;\n	color: #fff;\n	line-height: 1.7;\n"
    ]);
    CompareBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompareBox_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 38px;\n	padding: 0 30px;\n	border: 1px solid #fff;\n	background-color: transparent;\n	color: #fff;\n	line-height: 1.5;\n"
    ]);
    CompareBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CompareBox_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 38px;\n	padding: 0 30px;\n	border: none;\n	background-color: var(--emp-color);\n	color: #fff;\n	line-height: 1.5;\n"
    ]);
    CompareBox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Wrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9be5535c-0"
})(CompareBox_templateObject());
var Text = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-9be5535c-1"
})(CompareBox_templateObject1());
var DeselectButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-9be5535c-2"
})(CompareBox_templateObject2());
var CompareButton = styled_components_browser_esm["default"].button.withConfig({
    componentId: "sc-9be5535c-3"
})(CompareBox_templateObject3());
var CompareTextBox = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrap, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
            children: [
                "비교할 상품을 선택해주세요.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " 총 3개까지 선택하여",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " 비교하실 수 있습니다."
            ]
        })
    });
};
var CompareButtonBox = function(param) {
    var compare = param.compare, clear = param.clear;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DeselectButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "button"
            }, clear), {
                children: "선택 해제"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "button"
            }, compare), {
                children: "상품 비교"
            }))
        ]
    });
};


;// CONCATENATED MODULE: ./framework/ui/desktop/layout/WarningBox.tsx

function WarningBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	min-height: 600px;\n	text-align: center;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	gap: 30px;\n\n	&:before {\n		display: block;\n		width: 60px;\n		height: 60px;\n		background: url(",
        ') 0 -44px / 400px 400px no-repeat;\n		content: "";\n	}\n\n	p {\n		font-size: 15px;\n		color: var(--emp-color);\n	}\n'
    ]);
    WarningBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Box = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-679ae408-0"
})(WarningBox_templateObject(), (ico_spr_default()));
var WarningBox = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: children
        })
    });
};
/* harmony default export */ var layout_WarningBox = (WarningBox);

;// CONCATENATED MODULE: ./framework/ui/desktop/layout/index.tsx

function layout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 1200px;\n	margin: 0 auto;\n	padding-bottom: 100px;\n"
    ]);
    layout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function layout_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: ",
        ";\n	flex-direction: ",
        ";\n	justify-content: ",
        ";\n	gap: ",
        "px;\n	line-height: ",
        ";\n	flex-wrap: ",
        ";\n	flex-grow: ",
        ";\n"
    ]);
    layout_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function layout_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	width: 100%;\n	padding: 15px 0;\n	border-bottom: 2px solid var(--emp-color);\n	line-height: 1.25;\n	align-items: baseline;\n"
    ]);
    layout_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function layout_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 30px 0;\n	border-top: 1px solid var(--line-color);\n"
    ]);
    layout_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function layout_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	line-height: 1;\n	flex-direction: row;\n	align-items: baseline;\n"
    ]);
    layout_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function layout_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 60px 0 20px;\n"
    ]);
    layout_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function layout_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n"
    ]);
    layout_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function layout_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 910px;\n"
    ]);
    layout_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function layout_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	line-height: 1.6;\n	margin-top: 20px;\n	max-height: ",
        ";\n	overflow: hidden;\n\n	> div {\n		",
        "\n	}\n\n	/* pc */\n	@media (min-width: 736px) {\n		border: 1px solid var(--line-color);\n		padding: 35px 40px 40px;\n		box-sizing: border-box;\n	}\n"
    ]);
    layout_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	line-height: 1.6;\n	padding: 38px 40px 36px;\n	background-color: #f3f3f3;\n	font-size: var(--default-size);\n\n	h4,\n	p {\n		padding-left: 28px;\n		color: var(--emp-color);\n	}\n\n	h4 {\n		position: relative;\n		margin-bottom: 5px;\n\n		&:before {\n			position: absolute;\n			left: 0;\n			top: 50%;\n			display: block;\n			width: 18px;\n			height: 18px;\n			transform: translateY(-50%);\n			content: "";\n		}\n	}\n\n	p {\n		line-height: 1.6;\n	}\n\n	',
        "\n\n	",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-0"
})(layout_templateObject());
var Flex = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-1"
})(layout_templateObject1(), function(props) {
    return props.align;
}, function(props) {
    return props.direction ? "column" : "row";
}, function(props) {
    return props.justify;
}, function(props) {
    return props.gap ? props.gap : "0";
}, function(props) {
    return props.lineHeight;
}, function(props) {
    return props.wrap;
}, function(props) {
    return props.grow;
});
var LineHeader = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-2"
})(layout_templateObject2());
var ProdutList = styled_components_browser_esm["default"].ul.withConfig({
    componentId: "sc-9ed24f4e-3"
})(layout_templateObject3());
var Stack = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-4"
})(layout_templateObject4());
var SubTitleWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-5"
})(layout_templateObject5());
var DescriptionWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-6"
})(layout_templateObject6());
var DescriptionContent = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-7"
})(layout_templateObject7());
var LineBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-8"
})(layout_templateObject8(), function(props) {
    return props.elementHeight;
}, function(props) {
    return props.elementHeight && props.elementHeight !== "auto" ? "\n					max-height: 245px;\n				" : "";
});
var NoteBox = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-9ed24f4e-9"
})(_templateObject9(), function(props) {
    return props.icon === "point" && "\n		h4 {\n			&:before {\n				background: url(".concat((ico_spr_default()), ") no-repeat 0px -328px;\n			}\n		}\n	");
}, function(props) {
    return props.icon === "question" && "\n		h4 {\n			&:before {\n				height: 19px;\n				background: url(".concat((ico_spr_default()), ") no-repeat 0 -266px;\n			}\n		}\n	");
});





/***/ }),

/***/ 51820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iS": function() { return /* binding */ goodsAvailEventAsync; }
/* harmony export */ });
/* unused harmony exports getPath, key, goodsAvailEventSSR */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20414);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87633);






var key = "useGoodsAvailEvent";
/** ```
 *  해당 상품의 가장 빠른 행사 , 일자 , 전시된 월
 *   `/pkg/goods/${goodsCd}/available-date/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var getPath = function(goodsCd, searchType) {
    if (!goodsCd) return null;
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/").concat(goodsCd, "/available-date/").concat(searchType);
};
/** ```
 *  해당 상품의 가장 빠른 행사 , 일자 , 전시된 월
 *   `/pkg/goods/${goodsCd}/available-date/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var goodsAvailEventAsync = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(goodsCd) {
        var searchType, result, _tmp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    searchType = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "day";
                    _tmp = {};
                    return [
                        4,
                        (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(getPath(goodsCd, searchType), (_tmp.method = "GET", _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function goodsAvailEventAsync(goodsCd) {
        return _ref.apply(this, arguments);
    };
}();
/** ```
 *  해당 상품의 가장 빠른 행사 , 일자 , 전시된 월
 *   `/pkg/goods/${goodsCd}/available-date/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var goodsAvailEventSSR = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(goodsCd) {
        var searchType, result, _tmp;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    searchType = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "day";
                    _tmp = {};
                    return [
                        4,
                        (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(getPath(goodsCd, searchType), (_tmp.method = "GET", _tmp))
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return function goodsAvailEventSSR(goodsCd) {
        return _ref.apply(this, arguments);
    };
}();
/** ```
 *  해당 상품의 가장 빠른 행사 , 일자 , 전시된 월
 *   `/prdt/api/goods/${goodsCd}/available-date/{searchType}`
 * parameter
 *   `goodsCd` 상품코드
 *   `searchType` 검색타입 amt | day
 * ```*/ var useGoodsAvailEvent = function(goodsCd) {
    var searchType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "day", options = arguments.length > 2 ? arguments[2] : void 0;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(goodsCd, searchType)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(goodsCd, searchType)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["ZP"] = (useGoodsAvailEvent);



/***/ }),

/***/ 49195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPath */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83839);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32423);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87633);




/** ```
 * 제휴사 메뉴별 상품 리스트 조회
 *   `/pkg/goods/partner/{ptnCode}/by-menu/{dspSid}`
 * parameter
 *   `dspSid` 지역코드
 *   `ptnCode?` 파트너사 코드
 * ```*/ var key = "useGoodsPtnByMenu";
var getPath = function(dspSid, ptnCode) {
    return "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ENV_PORTAL_API_URL */ .Z.ENV_PORTAL_API_URL, "/pkg/goods/partner/").concat(ptnCode, "/by-menu/").concat(dspSid);
};
/** ```
 * 제휴사 메뉴별 상품 리스트 조회
 *   `/pkg/goods/partner/{ptnCode}/by-menu/{dspSid}`
 * parameter
 *   `dspSid` 지역코드
 *   `ptnCode?` 파트너사 코드
 * ```*/ var useGoodsPtnByMenu = function(dspSid, ptnCode, options) {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        queryKey: [
            key,
            getPath(dspSid, ptnCode)
        ],
        queryFn: function() {
            return (0,_FRAMEWORK_utils_useConfigureAxios__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
                url: getPath(dspSid, ptnCode)
            }).then(function(r) {
                return r.data;
            });
        },
        staleTime: 1000 * 30 * 60
    }, options));
};
/* harmony default export */ __webpack_exports__["Z"] = (useGoodsPtnByMenu);



/***/ }),

/***/ 14270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _COMPONENTS_partners_pages_common_desktop_Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92425);
/* harmony import */ var _COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96906);
/* harmony import */ var _QUERIES_bff_global_useGlobalMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98653);
/* harmony import */ var _QUERIES_prdt_goods_useGoodsOneAvailEvent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51820);
/* harmony import */ var _QUERIES_prdt_goods_useGoodsPtnByMenu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49195);
/* harmony import */ var _yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78860);
/* harmony import */ var _yb_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20279);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);













var LocalMain = function(props) {
    var ref, ref1;
    var query = props.query, partnerCode = props.partnerCode;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    /** 메뉴 카테고리 */ var globalMenu = (ref = (0,_QUERIES_bff_global_useGlobalMenu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        dspTypeCd: "A",
        dspSid: "A000000",
        level: "1,2,3,4"
    }).data) === null || ref === void 0 ? void 0 : ref.body;
    var menuLv2List = globalMenu.menuLv2List, menuLv3List = globalMenu.menuLv3List;
    var menuList = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(menuLv2List).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(menuLv3List));
    }, [
        globalMenu
    ]);
    var partnerGoodsFetch = (0,_QUERIES_prdt_goods_useGoodsPtnByMenu__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(query.dspSid, partnerCode, {
        placeholderData: {
            body: []
        }
    });
    var partnerGoods = partnerGoodsFetch.data.body || [];
    var localMainMenuList = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        var result = {
            thisMenuInfo: null,
            LocMenu: [],
            TmaMenu: []
        };
        if (!menuList) return result;
        return menuList.reduce(function(acc, cur) {
            var dspSid = cur.dspSid, dspSidHi = cur.dspSidHi, gnbTypeCd = cur.gnbTypeCd, locTypeCd = cur.locTypeCd, homeYn = cur.homeYn;
            dspSid === query.dspSid && (acc.thisMenuInfo = cur);
            if (dspSidHi === query.dspSid) {
                gnbTypeCd === "T" && locTypeCd === "L" && homeYn === "Y" && acc.LocMenu.push(cur);
                gnbTypeCd === "T" && locTypeCd === "T" && homeYn === "Y" && acc.TmaMenu.push(cur);
            }
            return acc;
        }, result);
    }, [
        menuList
    ]);
    var path = "/partners/".concat(query.$partnerName, "/localList");
    var goDetail = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(product) {
            var res, pathname, detailPath, _tmp, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,_QUERIES_prdt_goods_useGoodsOneAvailEvent__WEBPACK_IMPORTED_MODULE_4__/* .goodsAvailEventAsync */ .iS)(product.goodsCd)
                        ];
                    case 1:
                        res = _state.sent();
                        pathname = "/partners/".concat(query.$partnerName, "/detailPackage");
                        detailPath = "".concat(pathname, "?menu=").concat(query.menu, "&dspSid=").concat(product.dspSidHi, "&goodsCd=").concat(product.goodsCd, "&evCd=").concat(res.data.body.evCd);
                        _tmp = {};
                        router.push((_tmp.pathname = pathname, _tmp.query = {
                            menu: query.menu,
                            dspSid: product.dspSidHi,
                            goodsCd: product.goodsCd,
                            evCd: res.data.body.evCd,
                            partnerCode: partnerCode
                        }, _tmp), detailPath);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function goDetail(product) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_2__/* .Wrap */ .Eq, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_partners_pages_common_desktop_Header__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            localMainMenuList.LocMenu.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_2__/* .LocalmainTitle */ .nX, {
                        children: [
                            localMainMenuList.thisMenuInfo.dspNm,
                            " 지역 상품 바로가기"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_2__/* .LocalList */ .xC, {
                        children: localMainMenuList.LocMenu.map(function(menu, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "#",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        router.push({
                                            pathname: "".concat(path),
                                            query: {
                                                partnerCode: partnerCode,
                                                menu: menu.dspMenu,
                                                dspSid: menu.dspSid
                                            }
                                        }, "".concat(path, "?menu=").concat(menu.dspMenu, "&dspSid=").concat(menu.dspSid));
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: menu.dspNm
                                    })
                                })
                            }, index);
                        })
                    })
                ]
            }),
            localMainMenuList.TmaMenu.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_2__/* .LocalmainTitle */ .nX, {
                        children: "내륙/섬 테마 상품 바로가기"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_2__/* .LocalList */ .xC, {
                        children: localMainMenuList.TmaMenu.map(function(menu, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: "#",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        router.push("".concat(path, "?menu=").concat(menu.dspMenu, "&dspSid=").concat(menu.dspSid));
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: menu.dspNm
                                    })
                                })
                            }, index);
                        })
                    })
                ]
            }),
            partnerGoods.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_2__/* .LocalmainTitle */ .nX, {
                        children: [
                            (ref1 = localMainMenuList.thisMenuInfo) === null || ref1 === void 0 ? void 0 : ref1.dspNm,
                            " BEST 예약 상품"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_2__/* .ProductList */ .cm, {
                        children: partnerGoods.slice(0, 20)// eslint-disable-next-line no-nested-ternary
                        .sort(function(a, b) {
                            return a.minPrice > b.minPrice ? 1 : a.minPrice < b.minPrice ? -1 : 0;
                        }).map(function(product, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    href: "#",
                                    onClick: function(e) {
                                        e.preventDefault();
                                        goDetail(product);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_2__/* .Thumbnail */ .pl, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_12__/* .Noimage */ .T, {
                                                width: "285px",
                                                height: "195px",
                                                src: product.imageThum3,
                                                alt: "상품 이미지"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_2__/* .InfoBox */ .vD, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                    children: product.goodsNm
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_partners_styles__WEBPACK_IMPORTED_MODULE_2__/* .Pirice */ .p, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                            children: _yb_utils__WEBPACK_IMPORTED_MODULE_6__/* .format.koKRFormatNumber */ .WU.koKRFormatNumber(product.minPrice)
                                                        }),
                                                        " 원~"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (LocalMain);


/***/ }),

/***/ 99653:
/***/ (function(module) {

module.exports = "/_next/static/images/ico_spr.66pUW1wQ.png";

/***/ }),

/***/ 78860:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var e=__webpack_require__(85893),t=__webpack_require__(67294);function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}const c=i(__webpack_require__(93391)).default.div.withConfig({componentId:"sc-29a5abf2-0"})(["overflow:hidden;display:flex;justify-content:center;align-items:center;background-color:#eeeeee;width:100%;height:100%;img{max-width:100%;height:100%;&.fallback_thumb{object-fit:scale-down;max-height:100%;}}"]);exports.T=({src:i,fallback:a="https://cimgcdn.ybtour.co.kr/common/ybui/desktop/thumb_noimg.png",alt:n="",fallbackClassName:o="fallback_thumb",width:r,height:l,decoding:s})=>{const[d,h]=t.useState(!i);return t.useEffect((()=>{null==i||""===i.trim()?h(!0):h(!1)}),[i]),e.jsx(c,{style:{width:r,height:l},children:e.jsx("img",{src:d?a:i,alt:n,onError:()=>h(!0),className:`${d?o:""}`,decoding:s})})};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6906,9774,2888,179], function() { return __webpack_exec__(55153); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);